interface VisaSvgProps {
	className?: string;
}

/** Simplified Visa wordmark — not the official logotype, just a recognizable brand cue. */
function VisaSvg(prop: VisaSvgProps) {
	const { className } = prop;
	return (
		<svg viewBox="0 0 40 16" className={className} aria-label="Visa" role="img">
			<text
				x="0"
				y="13"
				fontFamily="Arial, Helvetica, sans-serif"
				fontStyle="italic"
				fontWeight="700"
				fontSize="16"
				fill="#1a1f71"
				direction="ltr"
			>
				VISA
			</text>
		</svg>
	);
}

export default VisaSvg;
